import styled from 'styled-components';

export const TextButton = styled.button`
  background: #fff;
  border-radius: 3px;
  cursor: pointer;
  height: ${({ btnHeight }) => btnHeight || '40px'};
  width: ${({ btnWidth }) => btnWidth || '180px'};
  box-shadow: ${({ noShadow }) => (noShadow ? 'none' : '0px 2px 4px rgba(0, 0, 0, 0.25)')};
  border: ${({ noShadow, noBorder }) => (noShadow && !noBorder ? '1px solid #eee' : 'none')};
  transition: box-shadow 0.3s;
  &:hover {
    box-shadow: ${({ noShadow }) => (noShadow ? '0px 2px 4px rgba(0, 0, 0, 0.25)' : '0px 5px 10px rgba(0, 0, 0, 0.25)')};
    transition: box-shadow 0.3s;
  }
  &:active,
  &:focus {
    outline: none;
    border: ${({ noShadow }) => (noShadow ? '1.5px solid #ddd' : 'none')};
  }
  transition: box-shadow 0.2s;
  img {
    width: 16px;
    height: 16px;
  }
  span {
    font-size: 11px;
  }
`;

export const TextButtonNotification = styled(TextButton)`
  background: ${({ color }) => (color ? `${String(color)}14` : '#fff')}; // 8% da cor
  height: ${({ btnHeight }) => btnHeight || 'auto'};
  width: ${({ btnWidth }) => btnWidth || 'auto'};
  padding: 4px 12px;
  margin-left: 16px;
  border-radius: 4px;
  span {
    margin-left: 4px;
    font-size: 10px;
  }
`;

export const IconButton = styled.button`
  background: transparent;
  border-radius: 50%;
  cursor: pointer;
  height: ${({ btnHeight }) => btnHeight || '50px'};
  width: ${({ btnWidth }) => btnWidth || '50px'};
  border: none;
  &:hover {
    transition: background 0.5s;
    background: rgba(0, 0, 0, 0.08);
  }
  &:active,
  &:focus {
    outline: none;
    border: none;
  }
`;

export const Icon = styled.img`
  width: ${({ iconWidth }) => iconWidth || '20px'};
  height: ${({ iconHeight }) => iconHeight || '20px'};
`;

export const Text = styled.span`
  padding-left: 10px;
  font: 500 13px 'Roboto', sans-serif;
  color: #565656;
  text-transform: uppercase;
`;

export const TextNotification = styled(Text)`
  padding-left: 0;
  color: ${({ color }) => color || '#fff'};
  text-transform: none;
`;
